var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f54aeba2-5ac0-4257-8e8f-9e9b53308fa9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,32.3a.72.72,0,0,1-.65-.28L8,26.84a.76.76,0,0,1-.27-.64A1.76,1.76,0,0,1,8,25.46L25.36,8.07A.77.77,0,0,1,26,7.79c.18,0,.55.1.64.28l5.18,5.18a1,1,0,0,1,0,1.39L14.54,32A.89.89,0,0,1,13.8,32.3Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,33.32a2.06,2.06,0,0,1-1.39-.56L7.23,27.58a1.69,1.69,0,0,1-.55-1.38,1.8,1.8,0,0,1,.46-1.39L24.62,7.33A1.71,1.71,0,0,1,26,6.78a3.55,3.55,0,0,1,1.38.55l5.18,5.18a2,2,0,0,1,0,2.77L15.28,32.67A1.71,1.71,0,0,1,13.8,33.32Zm0-2h0c.09.1.09,0,0,0h0L31.09,13.9,26,8.81h-.1L8.81,26v.19h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1,8.07a.63.63,0,0,1,.55.28l5.18,5.18A.51.51,0,0,1,32,14a.63.63,0,0,1-.28.55L14.36,31.84c-.19.18-.28.18-.56.18a.51.51,0,0,1-.46-.18L8.16,26.66a.72.72,0,0,1,0-1L25.54,8.26a.68.68,0,0,1,.56-.19m0-.55a1.29,1.29,0,0,0-.92.37L7.79,25.27a1.29,1.29,0,0,0,0,1.76L13,32.21a1.34,1.34,0,0,0,1.85,0L32.11,14.73a1.29,1.29,0,0,0,0-1.76L26.93,7.79a1.51,1.51,0,0,0-.83-.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,33.5a2.42,2.42,0,0,1-1.57-.65L7.05,27.68a2.3,2.3,0,0,1,0-3.15L24.44,7.15a2.38,2.38,0,0,1,3.14-.1l.09.1,5.18,5.17a2.3,2.3,0,0,1,0,3.15L15.46,32.85A2.64,2.64,0,0,1,13.8,33.5ZM9,26.2,13.8,31,30.91,14,26.1,9.18ZM26.1,9h0V8.44h0Zm.18-.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.52,
    y: 21.83,
    width: 1.02,
    height: 4.35,
    transform: "translate(-13.08 15.98) rotate(-44.43)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 19.59,
    width: 1.02,
    height: 4.35,
    transform: "translate(-10.89 16.87) rotate(-44.43)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.87,
    y: 17.49,
    width: 1.02,
    height: 4.25,
    transform: "translate(-8.78 18.03) rotate(-45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.04,
    y: 15.25,
    width: 1.02,
    height: 4.25,
    transform: "translate(-6.56 18.92) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.22,
    y: 13.15,
    width: 1.02,
    height: 4.25,
    transform: "translate(-4.43 19.84) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 10.91,
    width: 1.02,
    height: 4.25,
    transform: "translate(-2.22 20.72) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/Ruler.a53d0ad1c1eb6bdd3e3268b7665981a4.svg";
export { ForwardRef as ReactComponent };